var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdaptContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11699_1881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0.75H91C99.4223 0.75 106.25 7.57766 106.25 16V91C106.25 99.4223 99.4223 106.25 91 106.25H16C7.57766 106.25 0.75 99.4223 0.75 91V16C0.750001 7.57766 7.57766 0.75 16 0.75Z",
    fill: "#F8F8E7",
    stroke: "#91950F",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4932 83C39.9571 83 29 72.0562 29 58.5671H78C77.9864 72.0562 67.0292 83 53.4932 83Z",
    fill: "#91950F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4932 58.5671C42.4269 58.5671 33.462 49.6243 33.462 38.5853H73.538C73.5244 49.6107 64.5594 58.5671 53.4932 58.5671Z",
    fill: "#91950F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4932 38.5717C44.8694 38.5717 37.883 31.6025 37.883 23H69.117C69.1033 31.6025 62.117 38.5717 53.4932 38.5717Z",
    fill: "#91950F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11699_1881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 107,
    rx: 15.1059,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaptContent);
export default __webpack_public_path__ + "static/media/AdaptContent.4c9b85be1a86eb3c1b27ea51de3e070a.svg";
export { ForwardRef as ReactComponent };